import createReplacement from '../../createReplacement'
import getURLFromElem from '../../getURLFromElem'
import isBigEnoughToReplace from '../../isBigEnoughToReplace'


export default function replaceIframe({ consentConfig, iframe, supportedLocales }) {
  // If the space allocated for an iframe is big enough, we'll inject
  // an "Enable this content?" banner in into the DOM, right before
  // the iframe. But we don't do this for tiny iframes because we don't
  // want to disrupt the flow of the page.
  if ( isBigEnoughToReplace(iframe) ) {
    const { hostname } = getURLFromElem(iframe)

    const replacement = createReplacement({
      consentConfig,
      hostname,
      referenceNode: iframe,
      supportedLocales,
    })

    iframe.parentNode.insertBefore(replacement, iframe)
  }

  // Regardless of whether we're able to show a "enable this
  // content?" banner, we need to hide the iframe because no consent
  // has been given for it.
  iframe.dataset.display = iframe.style.display || 'block'

  // Some iframes have no `src` (e.g. an `about:blank` scratch frame that a
  // third-party SDK creates to borrow a clean realm). There's nothing to
  // stash or restore in that case, and reading the missing attribute would
  // stringify `null` into `data-src="null"`, which we'd later restore as a
  // literal `src="null"`--triggering a bogus request to <origin>/null.
  //
  // We use getAttribute() rather than `.src` because we restore this exact
  // value verbatim; `.src` would resolve it to an absolute URL.
  //
  const src = iframe.getAttribute('src')

  if ( src && !iframe.dataset.src ) {
    iframe.dataset.src = src
    iframe.removeAttribute('src')
  }

  iframe.style.display = 'none'
}
